import { render } from "./QualityPolicy.vue?vue&type=template&id=5e520ad8"
import script from "./QualityPolicy.vue?vue&type=script&lang=js"
export * from "./QualityPolicy.vue?vue&type=script&lang=js"

import exportComponent from "/home/armin/w/euro-petrol-website/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__